import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Icon, BtnComponent } from '@wam/components';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { AssignmentBatchItemResponse, AssignmentResponse } from '@wap/catalog-v5';
import { StudentAnalytics } from '@wam/shared';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'goal-save-result-dialog',
  templateUrl: './goal-save-result-dialog.component.html',
  styleUrls: ['./goal-save-result-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    BtnComponent,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    TranslatePipe,
  ],
})
export class GoalSaveResultDialogComponent {
  data = inject<{
    students: StudentAnalytics[];
    failures: AssignmentBatchItemResponse[];
    successes: AssignmentResponse[];
  }>(MAT_DIALOG_DATA);

  Icon = Icon;

  get failureStudentNames(): string[] {
    const studentNames = this.data.failures.map((assignment) => {
      const student = this.data.students.find(
        (student) => student.uuid === assignment.operationBody?.user,
      );
      return student.fullName;
    });

    return [...new Set(studentNames)];
  }

  get studentNames(): string[] {
    const studentNames = this.data.successes.map((assignment) => {
      const student = this.data.students.find((student) => student.uuid === assignment.user);
      return student.fullName;
    });

    return [...new Set(studentNames)];
  }
}
